import { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "src/components/layout/Header";
import MetaTag from "src/components/layout/MetaTag";
import { getMypageTitle } from "src/utils/app-Info";
import { useNavigateGoBack } from "src/pages/hooks/navigate-go-back";
import { InviteResult } from "../user-types";

/**
 * 마이페이지 메인 > 신청/계약 내역 > 상세 > 이용자 목록 > 이용자 초대 > 실패
 */
const UserInviteFail = () => {
  const { t } = useTranslation(["user"]);
  const location = useLocation();
  const { goBack } = useNavigateGoBack();

  // path variable 계약 id
  const { contractId } = useParams();

  const getErrorMessage = (errorCode?: string) => {
    switch (errorCode) {
      case "eCT101":
        return t("inviteUser.errorNotFound");
      case "eCT104":
      case "eCT602":
        return t("inviteUser.errorInvalidPhone");
      case "eCT204":
        return t("inviteUser.errorMaxExceeded");
      case "eCT303":
        return t("inviteUser.errorAlreadyInvited");
      case "eCT501":
        return t("inviteUser.errorNotFound");
      case "eCT502":
        return t("inviteUser.errorMissingParam");
      case "eCT601":
        return t("inviteUser.errorCannotInvite");
      default:
        return t("inviteUser.errorInvalidPhone");
    }
  };

  const inviteFailResults: InviteResult[] = useMemo(() => {
    if (!location.state) return [];
    return ((location.state as { inviteResults: InviteResult[] })?.inviteResults || []).filter(
      (inviteResult: InviteResult) => inviteResult.type === "FAIL",
    );
  }, [location]);

  return (
    <>
      <MetaTag title={getMypageTitle()} />
      <Header headerType="CLOSE" onClickCloseButton={() => goBack()} />
      <div className="user-invite-page">
        <h1 className="base-title">{t("inviteUser.title")}</h1>
        <article className="user-invite-fail">
          <div className="title-wrap">
            <h1>
              <Trans t={t} i18nKey="inviteUser.failTitle" components={{ br: <br /> }} />
            </h1>
          </div>
          <section>
            <div className="index-wrap">
              <h2>{t("inviteUser.failLabel")}</h2> <span>{t("inviteUser.countWithUnit", { count: inviteFailResults.length })}</span>
            </div>
            {inviteFailResults.map((inviteFailResult: InviteResult, index: number) => (
              <div key={index} className="list-line" style={inviteFailResults.length - 1 === index ? { borderBottom: "0px" } : {}}>
                <p>{inviteFailResult.phoneNumber || inviteFailResult.email}</p>
                <p>{getErrorMessage(inviteFailResult?.failErrorCode)}</p>
              </div>
            ))}
          </section>
        </article>
      </div>
    </>
  );
};
export default UserInviteFail;
